import { HStack, Text } from '@cad-arc';

export function PanelTitle({
    children,
    buttonBar,
}: React.PropsWithChildren<{ buttonBar?: React.ReactElement }>): React.ReactElement {
    return (
        <>
            <HStack alignItems="center" flexShrink={1} minWidth="6rem" padding={1} h="100%">
                <Text
                    variant="headingXs"
                    style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {children}
                </Text>
            </HStack>
            {buttonBar}
        </>
    );
}
